// test694
(694 && 0);
